import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  IUserSettingsState,
  loadOrInitUserSettings,
  shouldLoadUserSettings,
} from 'redux/reducers/userSettings';
import { RootState } from 'redux/rootReducer';
import { saveUserIsInterestedInAndroidApp } from 'redux/reducers/user/updateUsetIsInterestedInAndroidApp';

import { logToAmplitude } from 'helpers/logAmplitudeEvent';
import { ReactComponent as AndroidIcon } from 'icons/android-icon.svg';

import { Wrapper, MainText, SubText, Button } from './styles';

const AndroidSection: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dispatch(shouldLoadUserSettings())) {
      dispatch(loadOrInitUserSettings());
    }
  }, [dispatch]);

  const userSettings = useSelector(
    (state: RootState): IUserSettingsState => state.userSettings
  );

  const onButtonClick = (): void => {
    logToAmplitude('Interested in Android Notifier');
    dispatch(saveUserIsInterestedInAndroidApp(true));
  };

  return (
    <Wrapper>
      <MainText>
        Sorry, the OPUS Notifier App is not available for Android yet!
      </MainText>
      {!userSettings?.loading?.all ? (
        userSettings?.data?.userIsInterestedInAndroidApp ? (
          <SubText>
            Thank you for your interest in the OPUS Notifier App for Android.
          </SubText>
        ) : (
          <>
            <SubText>
              Click to register your interest on the Android app.
            </SubText>
            <Button marginBottom="2px" onClick={onButtonClick}>
              <AndroidIcon /> Register Your Interest
            </Button>
          </>
        )
      ) : null}
    </Wrapper>
  );
};

export default AndroidSection;
